import { takeLatest, put, all, call } from "redux-saga/effects";

import CompanyActionTypes from "./company.types";
import {
  companyDetailsAdd,
  companyDetailsUpdate,
  companyListGet,
  companyDetailsFetch,
  companyDetailsDelete,
  instanceDetailsAdd,
} from "./company.service";

import {
  addCompanyDetailsSuccess,
  addCompanyDetailsFailure,
  addCompanyDetailsResponseChanged,
  updateCompanyDetailsSuccess,
  updateCompanyDetailsFailure,
  updateCompanyDetailsResponseChanged,
  getCompanyListSuccess,
  getCompanyListFailure,
  getCompanyListResponseChanged,
  fetchCompanyDetailsSuccess,
  fetchCompanyDetailsFailure,
  fetchCompanyDetailsResponseChanged,
  deleteCompanyDetailsSuccess,
  deleteCompanyDetailsFailure,
  deleteCompanyDetailsResponseChanged,
  addInstanceDetailsFailure,
  addInstanceDetailsSuccess,
  addInstanceDetailsResponseChanged,
} from "./company.action";
import { encryptData } from "../../_common/enode-decode";

/** *********************  START GET COMPANY LIST  ******************** */
export function* companyDetailsListGet({ payload }: any) {
  try {
    const key = "GetAllCompanyPaginationKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      InputSearch: payload.searchValueSet,
      Limit: payload.limit,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(companyListGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getCompanyListFailure(responseData.data));
    } else {
      yield put(getCompanyListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getCompanyListFailure(error));
  }
}

export function* resetGetCompanyListResponse() {
  yield put(getCompanyListResponseChanged());
}

export function* onGetCompanyListDetails() {
  yield takeLatest(
    CompanyActionTypes.GET_COMPANY_LIST_START,
    companyDetailsListGet,
  );
}

export function* onGetCompanyListResponseReset() {
  yield takeLatest(
    CompanyActionTypes.GET_COMPANY_LIST_RESPONSE_RESET,
    resetGetCompanyListResponse,
  );
}
/** *********************  END GET COMPANY LIST ******************** */

/** ******************  START ADD COMPANY DETAILS  ******************** */
export function* createCompany({ payload }: any) {
  try {
    const key = "CreateCompanyKey";
    const jsonData = {
      CompanyName: payload.CompanyName,
      // UserName: payload.UserName,
      CreatedBy: payload.UserID,
      CompanyPhoneNo: payload.CompanyPhoneNo,
      CompanyWebsite: payload.CompanyWebsite,
      CompanyAddressLine1: payload.CompanyAddressLine1,
      CompanyAddressLine2: payload.CompanyAddressLine2,
      City: payload.city,
      State: payload.State,
      Zipcode: payload.zipcode,
      Country: payload.country,
      UserEmail: payload.UserEmail,
      UserPhoneNo: payload.UserPhoneNo,
      UserPassword: payload.AdminPassword,
      CreatedUserName: payload.UserName,
      UserName: payload.AdminName,
      CompanyLogo: payload.CompanyLogo,
      InstanceName: payload.instanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(companyDetailsAdd, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(addCompanyDetailsFailure(responseData.data));
    } else {
      yield put(addCompanyDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addCompanyDetailsFailure(error));
  }
}

export function* resetAddCompanyResponse() {
  yield put(addCompanyDetailsResponseChanged());
}

export function* onCreateCompanyDetails() {
  yield takeLatest(CompanyActionTypes.ADD_COMPANY_DETAILS_START, createCompany);
}

export function* onCreateCompanyResponseReset() {
  yield takeLatest(
    CompanyActionTypes.ADD_COMPANY_DETAILS_RESPONSE_RESET,
    resetAddCompanyResponse,
  );
}
/** *********************  END ADD COMPANY DETAILS ******************** */

/** *********************  START UPDATE COMPANY DETAILS  ******************** */
export function* companyUpdate({ payload }: any) {
  try {
    const key = "UpdateCompanyKey";
    const jsonData = {
      CompanyPhoneNo: payload.CompanyPhoneNo,
      CompanyID: payload.CompanyID,
      UserPhoneNo: payload.UserPhoneNo,
      UserEmail: payload.UserEmail,
      CompanyName: payload.CompanyName,
      CompanyWebsite: payload.CompanyWebsite,
      CompanyAddressLine1: payload.CompanyAddressLine1,
      CompanyAddressLine2: payload.CompanyAddressLine2,
      City: payload.city,
      State: payload.State,
      Zipcode: payload.zipcode,
      Country: payload.country,
      UpdatedBy: payload.UserID,
      UserTypeID: payload.UserTypeID,
      UserName: payload.AdminName,
      UserPassword: payload.AdminPassword,
      UserID: payload.userID,
      UpdatedUserName: payload.UserName,
      OldCompanyName: payload.OldCompanyName,
      CompanyLogo: payload.CompanyLogo,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(companyDetailsUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateCompanyDetailsFailure(responseData.data));
    } else {
      yield put(updateCompanyDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateCompanyDetailsFailure(error));
  }
}

export function* resetUpdateCompanyDetailsResponse() {
  yield put(updateCompanyDetailsResponseChanged());
}

export function* onUpdateCompanyDetails() {
  yield takeLatest(
    CompanyActionTypes.UPDATE_COMPANY_DETAILS_START,
    companyUpdate,
  );
}

export function* onUpdateCompanyResponseReset() {
  yield takeLatest(
    CompanyActionTypes.UPDATE_COMPANY_DETAILS_RESPONSE_RESET,
    resetUpdateCompanyDetailsResponse,
  );
}
/** *********************  END UPDATE COMPANY DETAILS ******************** */

/** *********************  START DELETE COMPANY DETAILS  ******************** */
export function* companyDelete({ payload }: any) {
  try {
    const key = "DeleteCompanyKey";
    const jsonData = {
      CompanyID: payload.companyID,
      // CompanyID: payload.CompanyID,
      CompanyName: payload.CompanyName,
      DeletedBy: payload.UserID,
      UserName: payload.UserName,
      InstanceName: payload.InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(companyDetailsDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteCompanyDetailsFailure(responseData.data));
    } else {
      yield put(deleteCompanyDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteCompanyDetailsFailure(error));
  }
}

export function* resetDeleteCompanyDetailsResponse() {
  yield put(deleteCompanyDetailsResponseChanged());
}

export function* onDeleteCompanyDetail() {
  yield takeLatest(
    CompanyActionTypes.DELETE_COMPANY_DETAILS_START,
    companyDelete,
  );
}

export function* onDeleteCompanyResponseReset() {
  yield takeLatest(
    CompanyActionTypes.DELETE_COMPANY_DETAILS_RESPONSE_RESET,
    resetDeleteCompanyDetailsResponse,
  );
}
/** *********************  END DELETE COMPANY DETAILS ******************** */

/** *********************  START FETCH COMPANY DETAILS  ******************** */
export function* fetchCompanyData({ payload }: any) {
  try {
    const key = "GetCompanyKey";
    const jsonData = {
      CompanyID: payload.CompanyID,
      InstanceName: payload.InstanceName,
      UserID: payload.UserID,
      UserType: payload.UserType,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(companyDetailsFetch, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchCompanyDetailsFailure(responseData.data));
    } else {
      yield put(fetchCompanyDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchCompanyDetailsFailure(error));
  }
}

export function* resetFetchCompanyDetailsResponse() {
  yield put(fetchCompanyDetailsResponseChanged());
}

export function* onFetchCompanyDetails() {
  yield takeLatest(
    CompanyActionTypes.FETCH_COMPANY_DETAILS_START,
    fetchCompanyData,
  );
}

export function* onFetchCompanyResponseReset() {
  yield takeLatest(
    CompanyActionTypes.FETCH_COMPANY_DETAILS_RESPONSE_RESET,
    resetFetchCompanyDetailsResponse,
  );
}
/** *********************  END FETCH COMPANY DETAILS ******************** */

/** ***************** ADD INSTANCE DETAILS START *********************** */
export function* addInstanceDetails({ payload }: any) {
  try {
    const { instanceName } = payload;
    const key = "CreateInstanceDBKey";
    const jsonData = {
      InstanceName: instanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(instanceDetailsAdd, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(addInstanceDetailsFailure(responseData.data));
    } else {
      yield put(addInstanceDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addInstanceDetailsFailure(error));
  }
}

export function* resetAddInstanceResponse() {
  yield put(addInstanceDetailsResponseChanged());
}

export function* onAddInstanceDetails() {
  yield takeLatest(
    CompanyActionTypes.ADD_INSTANCE_DETAILS_START,
    addInstanceDetails,
  );
}

export function* onAddInstanceDetailsResponseReset() {
  yield takeLatest(
    CompanyActionTypes.ADD_INSTANCE_DETAILS_RESPONSE_RESET,
    resetAddInstanceResponse,
  );
}
/** ***************** ADD INSTANCE DETAILS END *********************** */

export function* companySaga() {
  yield all([
    call(onCreateCompanyDetails),
    call(onCreateCompanyResponseReset),
    call(onUpdateCompanyDetails),
    call(onUpdateCompanyResponseReset),
    call(onGetCompanyListDetails),
    call(onGetCompanyListResponseReset),
    call(onFetchCompanyDetails),
    call(onFetchCompanyResponseReset),
    call(onDeleteCompanyDetail),
    call(onDeleteCompanyResponseReset),
    call(onAddInstanceDetails),
    call(onAddInstanceDetailsResponseReset),
  ]);
}
